import React from 'react';
import { Modal, Button } from '../ui';

const TransferModal = ({ 
  showModal, 
  onClose, 
  prop, 
  currentUser, 
  onSubmitTransfer 
}) => {
  if (!showModal || !prop) return null;

  const handleSubmit = () => {
    onSubmitTransfer(prop.id);
  };

  return (
    <Modal 
      isOpen={showModal} 
      onClose={onClose} 
      size="small"
      title="Request Transfer"
    >
      <Modal.Content>
        <div className="bg-gray-50 p-4 rounded-lg">
          <h4 className="font-medium mb-2">{prop.name}</h4>
          <div className="text-sm text-gray-600 space-y-1">
            <div><strong>From:</strong> {prop.owner}</div>
            <div><strong>To:</strong> {currentUser.organization}</div>
            <div><strong>Transfer Cost:</strong> ${prop.transfer_cost}</div>
            <div><strong>Estimated Time:</strong> {prop.transfer_time}</div>
          </div>
        </div>
      </Modal.Content>
      
      <Modal.Footer>
        <Button
          onClick={handleSubmit}
          variant="success"
          size="compact"
          className="flex-1"
        >
          Submit Request
        </Button>
        <Button
          onClick={onClose}
          variant="secondary"
          size="compact"
          className="flex-1"
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TransferModal;